import moment from "moment";
import {useEffect} from "react";


//0.045 = 5km
// export const haversine_distance = (mk1, mk2) => { //mk1 [lat, lng], mk2 [lat, lng]
//     const R = 6371; // Radius of the Earth in kilometers
//     const rlat1 = mk1[0] * (Math.PI / 180); // Convert degrees to radians
//     const rlat2 = mk2[0] * (Math.PI / 180); // Convert degrees to radians
//     const difflat = rlat2 - rlat1; // Radian difference (latitudes)
//     const difflon = (mk2[1] - mk1[1]) * (Math.PI / 180); // Radian difference (longitudes)
//
//     const d = 2 * R * Math.asin(
//         Math.sqrt(
//             Math.sin(difflat / 2) *
//             Math.sin(difflat / 2) +
//             Math.cos(rlat1) *
//             Math.cos(rlat2) *
//             Math.sin(difflon / 2) *
//             Math.sin(difflon / 2)
//         )
//     );
//     return d;
// }

// export const colors = ["#53be53", "#F6E604", "#FEA100", "#fea100", "#EC3303", "#980075", "#980075", "#7D0022"];
export const colors = ["#53BE53", "#F6E604", "#FEA100", "#EC3303", "#980075", "#7D0022"];

const getOrCreateTooltip = (chart) => {
    let tooltipEl = chart.canvas.parentNode.querySelector('div');
    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.borderRadius = '3px';
        tooltipEl.style.color = 'white';
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-50%, 0)';
        tooltipEl.style.transition = 'all .1s ease';

        const table = document.createElement('table');
        table.style.margin = '0px';

        tooltipEl.appendChild(table);
        chart.canvas.parentNode.appendChild(tooltipEl);
    }

    return tooltipEl;
};


export const outputNameHazard = (aqi) => {
    const names = [
        "Good",
        "Moderate",
        "Unhealthy for sensitive groups",
        "Unhealthy",
        "Very unhealthy",
        "Hazardous"
    ]

    return names[aqi];
}

export function tooltypeChartTwo(context) {
    // Tooltip Element
    const {chart, tooltip} = context;
    const tooltipEl = getOrCreateTooltip(chart);

    // Hide if no tooltip
    if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }
    // Set Text
    if (tooltip.body) {
        const titleLines = tooltip.title || [];
        const bodyLines = tooltip.body.map(b => b.lines);

        const tableHead = document.createElement('thead');

        titleLines.forEach(title => {
            const tr = document.createElement('tr');
            tr.style.borderWidth = 0;

            const th = document.createElement('th');
            th.style.borderWidth = 0;

            const text = document.createTextNode(title);

            th.appendChild(text);
            tr.appendChild(th);
            tableHead.appendChild(tr);
        });

        const tableBody = document.createElement('tbody');
        bodyLines.forEach((body, i) => {
            const colors = tooltip.labelColors[i];

            const span = document.createElement('span');
            span.style.background = colors.backgroundColor;
            span.style.borderColor = colors.borderColor;
            span.style.borderWidth = '2px';
            span.style.marginRight = '10px';
            span.style.height = '10px';
            span.style.width = '10px';
            span.style.display = 'inline-block';

            const tr = document.createElement('tr');
            tr.style.backgroundColor = 'inherit';
            tr.style.borderWidth = 0;

            const td = document.createElement('td');
            td.style.borderWidth = 0;
            //here need logic get data
            const text = document.createTextNode(body);

            td.appendChild(span);
            td.appendChild(text);
            tr.appendChild(td);
            tableBody.appendChild(tr);
        });

        const tableRoot = tooltipEl.querySelector('table');

        // Remove old children
        if (tableRoot) {
            while (tableRoot.firstChild) {
                tableRoot.firstChild.remove();
            }
        }

        // Add new children
        tableRoot.appendChild(tableHead);
        tableRoot.appendChild(tableBody);
    }

    const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;

    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
    tooltipEl.style.font = tooltip.options.bodyFont.string;
    tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
}

export function useOutsideAlerter(ref, fn) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                fn();
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

export const haversineDistance = (mk1, mk2) => { //mk1 [lat, lng], mk2 [lat, lng]
    const R = 6371; // Radius of the Earth in kilometers
    const rlat1 = mk1[0] * (Math.PI / 180); // Convert degrees to radians
    const rlat2 = mk2[0] * (Math.PI / 180); // Convert degrees to radians
    const difflat = rlat2 - rlat1; // Radian difference (latitudes)
    const difflon = (mk2[1] - mk1[1]) * (Math.PI / 180); // Radian difference (longitudes)

    const d = 2 * R * Math.asin(
        Math.sqrt(
            Math.sin(difflat / 2) *
            Math.sin(difflat / 2) +
            Math.cos(rlat1) *
            Math.cos(rlat2) *
            Math.sin(difflon / 2) *
            Math.sin(difflon / 2)
        )
    );
    return d;
}
export const getAqiColor = (index) => {
    let color = "";
    switch (index) {
        case 0:
            color = "#53be53";
            break;
        case 1:
            color = "#F6E604";
            break;
        case 2:
            color = "#FEA100";
            break;
        case 3:
            color = "#FEA100";
            break;
        case 4:
            color = "#EC3303";
            break;
        case 5:
            color = "#980075";
            break;
        case 6:
            color = "#980075";
            break;
        case 7:
            color = "#7D0022";
            break;
    }
    return color;
}
export const getRangeLevel = (value, min, max, maxLevel = 7) => {
    if (value === null || value === undefined || Number.isNaN(value)) return 0;
    if (max <= min) return 0;
    const clampedValue = Math.min(Math.max(value, min), max);
    const ratio = (clampedValue - min) / (max - min);
    return Math.round(ratio * maxLevel);
}
export const chartTwo = (dataChart) => {
    let colors = ["#53be53", "#F6E604", "#FEA100", "#EC3303", "#980075", "#7D0022"];
    let data = {
        labels: [],
        datasets: new Array(6).fill(0)
    };


    for (let i = 0; i <= 23; i++) {
        let date = moment().subtract(i, "hours").format('HH');
        data.labels.push(date);
        data.datasets[i] = {
            label: i,
            data: {}, //7
            backgroundColor: new Array(7).fill(colors[i]),
            borderColor: new Array(7).fill(colors[i]),
            borderWidth: 1
        };
        //Preparation Data
        if (dataChart[date]) {
            dataChart[date].forEach(item => {
                if(item.aqiLevel <= 7) {
                    let param = 0;
                    if (item.aqiLevel >= 3) {
                        param = 1;
                    } else if (item.aqiLevel >= 6) {
                        param = 2;
                    }
                    if (!data.datasets[item.aqiLevel - param]) {
                        data.datasets[item.aqiLevel - param] = {
                            label: i,
                            data: {}, //7
                            backgroundColor: new Array(7).fill(colors[item.aqiLevel - param]),
                            borderColor: new Array(7).fill(colors[item.aqiLevel - param]),
                            borderWidth: 1
                        };
                    }
                    if (!data.datasets[item.aqiLevel - param].data[date]) {
                        data.datasets[item.aqiLevel - param].data[date] = []
                    }
                    data.datasets[item.aqiLevel - param].data[date].push(item.aqiValue);
                }
            });
        }
    }

    //deploy data
    data.datasets.forEach((item, index) => {
        let prepareData = [];
        for (let i in item.data) {
            let copyData = [...item.data[i]];
            item.data[i] = copyData.reduce((a, b) => a + b, 0) / copyData.length;
        }
        for (let i = 0; i <= 6; i++) {
            let date = moment().subtract(i, "days").format('D');
            if (item && item.data && item.data[date]) {
                prepareData.push(item.data[date]);
            } else {
                prepareData.push(0);
            }
        }
        item.data = prepareData;
    });


    return data;
}
export const chartOne = (dataChart, fnColor = getAqiColor, value = "aqiValue", level = "aqiLevel", label = "AQI Average", text = "Hours", maxY = 400, minY = 0) => {
    // const date = moment().subtract(7, "days").format('D');


    let data = {
        labels: [],
        datasets: [
            {
                label: '',
                data: [], //7
                backgroundColor: [],
                borderColor: [],
                borderWidth: 1
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: label,
                font: {
                    weight: "bold"
                }
            }
        },
        scales: {
            y: {
                max: maxY,
                min: minY,
                ticks: {
                    stepSize: 50
                }
                ,
                title: {
                    display: true,
                    text: label
                }
            },
            x: {
                title: {
                    display: true,
                    text: text
                }
            },
        },
        maintainAspectRatio: false
    };
    for (let i = 0; i <= 23; i++) {
        let date = moment().subtract(i, "hours").format('HH');
        data.labels.push(date);
        if (dataChart[date]) {
            data.datasets[0].data.push(dataChart[date][value]);
            data.datasets[0].backgroundColor.push(fnColor(dataChart[date][level]));
            data.datasets[0].borderColor.push(fnColor(dataChart[date][level]));
        } else {
            data.datasets[0].data.push(0);
            data.datasets[0].backgroundColor.push(fnColor(0));
            data.datasets[0].borderColor.push(fnColor(0));
        }
    }
    // data.datasets[0].backgroundColor.reverse();
    // data.datasets[0].borderColor.reverse();

    return {data, options};
}

//
// let geocoder;
//
// function initialize() {
//     geocoder = new google.maps.Geocoder();
// }
//
// export function codeLatLng(lat, lng) {
//     const latlng = new google.maps.LatLng(lat, lng);
//     geocoder.geocode({
//         'latLng': latlng
//     }, function (results, status) {
//         if (status === google.maps.GeocoderStatus.OK) {
//             if (results[1]) {
//                 console.log(results[1]);
//             } else {
//                 alert('No results found');
//             }
//         } else {
//             alert('Geocoder failed due to: ' + status);
//         }
//     });
// }

export const averageDataLogs = (data, key) => {
    let keys = key.split(".");
    if(keys.length) {
        return data.reduce((acc, i) => {
            if(i?.[keys[0]]?.[keys[1]]) {
                acc = acc + i[keys[0]][keys[1]].v
            }
            return acc;
        }, 0)/data.length; 
    }
    return null;
}